import 'braid-design-system/reset';
import { BraidProvider, Box } from 'braid-design-system';
import seekJobs from 'braid-design-system/themes/seekJobs';
import { useRoutes } from 'react-router';

import { LocalDemoProvider } from '#src/context/LocalDemoContext';
import { routes } from '#src/routes';

export default () => (
  <BraidProvider theme={seekJobs}>
    <LocalDemoProvider>
      <Box>{useRoutes(routes)}</Box>
    </LocalDemoProvider>
  </BraidProvider>
);
